/**
 * Formulario de recuperación de contraseña con envío de email.
 */
import React from "react";
import { Button, Form, Input, Typography } from "antd";
import { UserOutlined } from "@ant-design/icons";

const RecoverForm = ({
  form,
  loading,
  onFinishForgot,
  handleBackToLogin,
  onLoading,
  recoverResponse,
}) => {
  return (
    <>
      {recoverResponse ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            gap: 8,
          }}
        >
          <Typography.Text>{recoverResponse?.resultadoInterface?.mensaje}</Typography.Text>
          <Typography.Text strong>{recoverResponse?.mail}</Typography.Text>

          <div className="back-to-login-wrapper">
            <Typography.Text
              className="forgot-password-text"
              style={{ color: "#791ea3" }}
              onClick={handleBackToLogin}
            >
              Volver al inicio de sesión
            </Typography.Text>
          </div>
        </div>
      ) : (
        <Form
          requiredMark={false}
          form={form}
          layout="vertical"
          style={{ width: "100%", maxWidth: "320px", margin: "0 auto" }}
          name="forgot-password-form"
          onFinish={onFinishForgot}
          autoComplete="off"
        >
          <div className="forgot-password-title">
            <Typography.Title
              level={5}
              style={{
                margin: "1rem 0",
                textAlign: "center",
                wordBreak: "break-word",
              }}
            >
              Ingresa tu nombre de usuario para recuperar la contraseña
            </Typography.Title>
          </div>

          <Form.Item
            name="username"
            rules={[{ required: true, message: "Por favor ingresa tu usuario" }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Nombre de usuario"
              style={{
                borderRadius: "12px",
                padding: "10px 12px",
                fontSize: "1rem",
              }}
            />
          </Form.Item>

          <Form.Item>
            <Button
              style={{
                borderRadius: "12px",
                padding: "20px",
                fontSize: "1rem",
                transition: "all 0.3s ease",
              }}
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              onClick={() => {
                const { username } = form.getFieldsValue();
                if (username) onLoading();
              }}
            >
              Recuperar contraseña
            </Button>
          </Form.Item>

          <div className="back-to-login-wrapper">
            <Typography.Text
              className="forgot-password-text"
              style={{ color: "#791ea3" }}
              onClick={handleBackToLogin}
            >
              Volver al inicio de sesión
            </Typography.Text>
          </div>
        </Form>
      )}
    </>
  );
};
export default RecoverForm;
